unit Client.Core;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Modules, XData.Web.Connection, Math, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client,
  DateUtils, Client.Constants, WEBLib.Dialogs, WEBLib.Forms, WEBLib.Cookies, WEBLIB.Storage, WEBLib.ExtCtrls, App.Types;

type
  TmodMain = class(TDataModule)
    connServer: TXDataWebConnection;
    cliMain: TXDataWebClient;
    procedure connServerRequest(Args: TXDataWebConnectionRequest);
    procedure connServerConnect(Sender: TObject);
    procedure connServerError(Error: TXDataWebConnectionError);
    procedure connServerResponse(Args: TXDataWebConnectionResponse);
  private
    { Private declarations }
    FOnConnected: TOnLineEvent;
    FUnauthorizedAccessProc: TUnauthorizedAccessProc;
  public
    { Public declarations }
    PristanisceId: integer;

    // Skupno
    function GetVar(TokenName: string): string;
    procedure SetVar(TokenName, Value: string);

    property OnConnected: TOnLineEvent read FOnConnected write FOnConnected;

    procedure Log(Txt: string);

    procedure InitApp(SuccessProc: TSuccessProc; UnauthorizedAccessProc: TUnauthorizedAccessProc);

    procedure NastaviPristanisce(Id: integer; Naziv: string);
  protected procedure LoadDFMValues; override; end;

var
  modMain: TmodMain;

implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}

uses Main, Auth.Service, App.Config;

{$R *.dfm}

procedure TmodMain.connServerConnect(Sender: TObject);
begin
  Log('Connected to server');
end;

procedure TmodMain.connServerError(Error: TXDataWebConnectionError);
begin
  Log('Connection error: '+Error.ErrorMessage);
end;

procedure TmodMain.connServerRequest(Args: TXDataWebConnectionRequest);
begin
  if AuthService.Authenticated then
    Args.Request.Headers.SetValue('Authorization', 'Bearer ' + AuthService.GetToken);
end;

procedure TmodMain.connServerResponse(Args: TXDataWebConnectionResponse);
begin
  if Args.Response.StatusCode = 401 then
    FUnauthorizedAccessProc(Format('%d: %s',[Args.Response.StatusCode, Args.Response.ContentAsText]));
end;

function TmodMain.GetVar(TokenName: string): string;
var
  ls: TLocalStorage;
begin
  Result := '';
  ls := TLocalStorage.Create;
  try
    Result := ls.GetValue(TokenName);
  finally
    ls.free;
  end;
end;

procedure TmodMain.Log(Txt: string);
begin
//  if AppSettings.DevMode then
    Console.Log(Txt);
end;

procedure TmodMain.SetVar(TokenName, Value: string);
var
  ls: TLocalStorage;
begin
  ls := TLocalStorage.Create;
  try
    ls.SetValue(TokenName, Value);
  finally
    ls.free;
  end;
end;


procedure TmodMain.InitApp(SuccessProc: TSuccessProc; UnauthorizedAccessProc: TUnauthorizedAccessProc);

  procedure ConfigLoaded(Config: TAppConfig);
  begin
    if Config.ApiUrl <> '' then
      connServer.URL := Config.ApiUrl;

    connServer.Open(SuccessProc);
  end;

begin
  FUnauthorizedAccessProc := UnauthorizedAccessProc;
  LoadConfig(@ConfigLoaded);
end;

procedure TmodMain.NastaviPristanisce(Id: integer; Naziv: string);
begin
  PristanisceId := Id;
  frmMain.lblPristanisce.Caption := Naziv;
end;

procedure TmodMain.LoadDFMValues;
begin
  inherited LoadDFMValues;

  connServer := TXDataWebConnection.Create(Self);
  cliMain := TXDataWebClient.Create(Self);

  connServer.BeforeLoadDFMValues;
  cliMain.BeforeLoadDFMValues;
  try
    Name := 'modMain';
    Height := 423;
    Width := 594;
    connServer.SetParentComponent(Self);
    connServer.Name := 'connServer';
    connServer.URL := 'https://marinaioapi.okoljepiran.si/pantalon';
    SetEvent(connServer, Self, 'OnConnect', 'connServerConnect');
    SetEvent(connServer, Self, 'OnError', 'connServerError');
    SetEvent(connServer, Self, 'OnRequest', 'connServerRequest');
    SetEvent(connServer, Self, 'OnResponse', 'connServerResponse');
    connServer.Left := 32;
    connServer.Top := 8;
    cliMain.SetParentComponent(Self);
    cliMain.Name := 'cliMain';
    cliMain.Connection := connServer;
    cliMain.Left := 32;
    cliMain.Top := 62;
  finally
    connServer.AfterLoadDFMValues;
    cliMain.AfterLoadDFMValues;
  end;
end;

end.
